import { render, staticRenderFns } from "./cookieBanner.app.vue?vue&type=template&id=223006c5"
import script from "./cookieBanner.app.vue?vue&type=script&lang=ts"
export * from "./cookieBanner.app.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports